import React, { useState } from 'react';
import { Formik, Form, Field } from 'formik';
import Services from '../../services';
import { V2_FORGOT_PASSWORD_URL } from '../../consts/api';
import { isResponseSuccess } from '../../helpers';
import InputField from 'customField/InputField';
import { validationForgotPassword } from 'consts/validateSchema';
import { useHistory } from 'react-router';
import NewDesign from 'components/NewDesign';
import forgotPassword from './forgotPassword.svg';
import { AppRoutes } from 'consts/routesPath';
import { notifySuccess } from 'helpers/handleNotification';

const initialValues = {
  email: '',
};

const ForgotPassword = () => {
  //!State
  const [state, setState] = useState({
    success: false,
    error: null,
  });
  const { error, success } = state;
  const history = useHistory();

  //! Function
  const handleOnSubmit = async (values, { setSubmitting }) => {
    setState((prev) => ({ ...prev, error: null }));
    try {
      const res = await Services.post(V2_FORGOT_PASSWORD_URL, values);
      if (isResponseSuccess(res.status) && res.data && res.data.status === 'success') {
        setState((prev) => ({ ...prev, success: true }));
        notifySuccess('Request success. Please check your email.', 'Success');
      } else {
        throw Error(res?.data?.error?.error || 'No response');
      }
    } catch (error) {
      try {
        setState((prev) => ({ ...prev, error: JSON.parse(error).error }));
      } catch (e) {
        setState((prev) => ({ ...prev, error: error.toString() }));
      }
    }

    setSubmitting(false);
  };

  //! Render
  return (
    <div className='center flex-column login_page'>
      <div
        className='login_page__logo'
        style={{
          backgroundImage: `url(https://textback.ai/wp-content/uploads/2019/09/Textback_logo-e1568115685184.png)`,
        }}
      ></div>
      <div className='container'>
        <div className='forgotPassword form'>
          <div className='center' style={{ width: '100%', height: '100%' }}>
            <div className='center flex-column ' style={{ width: '350px' }}>
              <div className='header'>FORGOT PASSWORD</div>

              {success ? (
                <div className='alert alert-success' role='alert'>
                  Request success. Please check your email.
                </div>
              ) : (
                <div className='form-text text-muted mb-4'>
                  Please enter your email address below and we will send you a link to reset your
                  password
                </div>
              )}
              <Formik
                validateOnBlur={false}
                validateOnChange={false}
                onSubmit={handleOnSubmit}
                initialValues={initialValues}
                validationSchema={validationForgotPassword}
              >
                {({ isSubmitting, values }) => {
                  return (
                    <Form className='center tw-gap-[20px] flex-column tw-w-full '>
                      <div className=' justify-content-center tw-gap-[8px] flex-column tw-w-full'>
                        <Field
                          name='email'
                          type='email'
                          component={InputField}
                          label='Email'
                          required
                          placeholder='Input your email'
                        />
                      </div>
                      {error && (
                        <div className='alert alert-danger' role='alert'>
                          {error}
                        </div>
                      )}
                      <div className='d-flex tw-gap-[5px] flex-column tw-w-full'>
                        <NewDesign.Button
                          type='submit'
                          className='tw-w-full'
                          isLoading={isSubmitting}
                          disabled={isSubmitting}
                        >
                          Submit
                        </NewDesign.Button>
                        <NewDesign.Button
                          type='button'
                          className='tw-w-full'
                          isLoading={isSubmitting}
                          disabled={isSubmitting}
                          onClick={(e) => {
                            e.preventDefault();
                            history.push(AppRoutes.Login);
                          }}
                          outline
                        >
                          Back to login
                        </NewDesign.Button>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
        <div
          className='container__background right'
          style={{ backgroundImage: `url(${forgotPassword})` }}
        ></div>
      </div>
      <div className='copy_right'>Copyright &copy; 2021 &mdash; Textback.ai</div>
    </div>
  );
};

export default ForgotPassword;
